var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.imageURL(_vm.record.image_url)},on:{"click":function($event){$event.preventDefault();_vm.imageIndex = 0}}}),_c('CoolLightBox',{attrs:{"items":_vm.galleryImages,"index":_vm.imageIndex},on:{"close":function($event){_vm.imageIndex = null}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }